import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { DropdownContainer, DropdownPopup, MenuItemButton, MenuDivider } from './styles'

export const DropdownMenu = ({ trigger, items }) => {
  const [open, setOpen] = useState(false)
  const containerRef = useRef(null)

  useEffect(() => {
    if (!open) return
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [open])

  const handleItemClick = (onClick) => {
    return (e) => {
      onClick && onClick(e)
      setOpen(false)
    }
  }

  return (
    <DropdownContainer ref={containerRef}>
      <div onClick={() => setOpen((prev) => !prev)}>
        {trigger}
      </div>
      {open && (
        <DropdownPopup>
          {items.map((item, index) =>
            item.divider ? (
              <MenuDivider key={`divider-${index}`} />
            ) : (
              <MenuItemButton
                key={item.label || index}
                onClick={handleItemClick(item.onClick)}
                disabled={item.disabled}
              >
                {item.icon && item.icon}
                {item.label}
              </MenuItemButton>
            )
          )}
        </DropdownPopup>
      )}
    </DropdownContainer>
  )
}

DropdownMenu.propTypes = {
  trigger: PropTypes.node.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      icon: PropTypes.node,
      onClick: PropTypes.func,
      divider: PropTypes.bool,
      disabled: PropTypes.bool,
    })
  ).isRequired,
}
